import ContactInfoFormBlock from './ContactInfoFormBlock'

export default ContactInfoFormBlock
